<script setup lang="ts">
import { Feature } from 'ol'
import { Geometry } from 'ol/geom'
import GeoJSON from 'ol/format/GeoJSON'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'

defineProps<{ features: Feature<Geometry>[] }>()
const layer = ref<{ vectorLayer: VectorLayer<VectorSource<Geometry>> }>()
const geoJson = new GeoJSON()
const { visible } = inject<{ visible: Ref<boolean> }>('layerControl', { visible: ref(false) })

watch(visible, (newValue) => {
  layer.value && layer.value.vectorLayer.setVisible(newValue)
})

watch(layer, (newValue) => {
  if (newValue) {
    newValue.vectorLayer.setVisible(visible.value)
  }
})
</script>
<template>
  <ol-vector-layer ref="layer" :class-name="'vectorlayer'" :z-index="2">
    <ol-source-vector :features="features" :format="geoJson"> </ol-source-vector>
    <ol-style>
      <ol-style-stroke color="#aaa" :width="2"></ol-style-stroke>
      <ol-style-fill color="transparent"></ol-style-fill>
    </ol-style>
  </ol-vector-layer>
</template>
